module.exports = __webpack_public_path__ + "static/work-schedule-3e9e4b913c98a30ab7e435d286973915.jpeg";